import React from "react";
import { Hero } from "@/components/site/Hero";
import { Marquee, StatsStrip, Positioning, GrowthLifecycle } from "@/components/site/InstitutionSections";
import { Services, FlagshipDashboard } from "@/components/site/Services";
import { ClientNetwork, CaseStudies, StudentSearch, StudentJourney } from "@/components/site/NetworkStudent";
import { Testimonials } from "@/components/site/Testimonials";
import { WhyA3, OperatingModel, AITech, ExtendedTeam, CompanyStory, Office, FinalCTA } from "@/components/site/AboutSections";

export default function Home() {
  return (
    <main>
      <Hero />
      <Marquee />
      <StatsStrip />
      <Positioning />
      <GrowthLifecycle />
      <Services />
      <FlagshipDashboard />
      <ClientNetwork />
      <CaseStudies />
      <div id="students">
        <StudentSearch />
        <StudentJourney />
      </div>
      <Testimonials />
      <WhyA3 />
      <OperatingModel />
      <AITech />
      <ExtendedTeam />
      <CompanyStory />
      <Office />
      <FinalCTA />
    </main>
  );
}
